declare global {
  interface Window {
    onSherpaEvent: (event: { type: string }) => void
    $sherpa: {
      V2: {
        createElement: (
          type: string,
          options: any
        ) => {
          mount: (selector: string) => void
        }
      }
    }
  }
}

interface IParams {
  widgetConfig: any
  widgetSelector: string
  widgetType: 'trip' | 'map'
}

export const useSherpaWidget = ({ widgetConfig, widgetSelector, widgetType }: IParams) => {
  const config = useRuntimeConfig()
  const SHERPA_WIDGET = {
    params: {
      appId: config.public.sherpaAppId,
      affiliateId: 'airbaltic'
    },

    url: 'https://sdk.joinsherpa.io/widget.js'
  }
  const SHERPA_WIDGET_URL = `${SHERPA_WIDGET.url}?${new URLSearchParams(SHERPA_WIDGET.params).toString()}`

  const localeStore = useLocaleStore()

  const SUPPORTED_LANGUAGE_LIST = [
    'ar',
    'da',
    'de',
    'en',
    'es',
    'fi',
    'fr',
    'is',
    'it',
    'nl',
    'no',
    'pt',
    'ru',
    'sv',
    'tr',
    'zh',
    'lv'
  ]
  const language = computed(() => {
    let lang = localeStore.selectedLanguage

    if (!SUPPORTED_LANGUAGE_LIST.includes(lang)) {
      lang = 'en'
    }

    return lang
  })

  const isMountInProgress = ref(false)

  onBeforeMount(() => {
    useHead({
      script: [
        {
          src: SHERPA_WIDGET_URL
        }
      ]
    })

    window.onSherpaEvent = (event) => {
      if (event.type === 'sdkLoaded' && !isMountInProgress.value) {
        isMountInProgress.value = true

        window.$sherpa.V2.createElement(widgetType, {
          language: language.value,
          ...widgetConfig
        }).mount(`#${widgetSelector}`)
      }
    }
  })
}
